import React from 'react'; 
import '../Artists/Zen-Frescos/Zen-Frescos.css'; 
import Navbar from '../Navbar/Navbar'; 

function ArtService() {
    return (
      <>
          
          <div className="Art-Service">
          <form method="get" action="#/art-service-mandarin">
            <button id="the-button" type='btn'>普通話</button> 
          </form> 
            <h1 className="artist">Art Service</h1> 
            <hr /> 

            <br /> 

            <p id="art-paragraph-other">
            The American Dragon Gallery has a strong team of art consultants. The consultants have senior qualifications 
            related to various international art fields.  They try their best to recommend some of the most talented potential 
            artists to display their works at The American Dragon Gallery.  In addition, our team helps artists establish 
            cooperation opportunities with the world’s best galleries and auction venues, such as Sotheby’s, Christies, Art 
            Basel, private collectors, and museums.  This professional team will help showcase the artist’s talents through 
            exhibitions, seminars, transnational residency creations, and auctions.  We use our resources related to our global 
            partner network to help distribute the high quality artwork.  American Dragon adopts an open, inclusive, and 
            diversified attitude, attracting talented and creative artists from all walks of life.  Please contact us to learn 
            more about our services. 
            </p>

            <br /> 

            <p id="art-paragraph-other">
            Phone: 917-886-1701
            </p> 

            <p id="art-paragraph-other">
            Email: info@americandragonfineart.com 
            </p> 

            <br />
            <hr /> 
            <br /> 
             
            <h1 className="artist-uh">Chinese Art Tour</h1> 

            <h5 id="caption-uh">
            Day 1: Arrive in Beijing
            </h5>
            <p id="art-paragraph-bottom">
            Upon arrival, the tour representative will meet you at the airport and escort you to your hotel. 
            </p>
            <p id="art-paragraph-bottom-mobile">
            Upon arrival, the tour representative will meet you at the airport and escort you to your hotel. 
            </p>
            <br /> 

            <h5 id="caption-uh">
            Day 2: Beijing
            </h5>
            <p id="art-paragraph-bottom">
            Opening reception or free event day for your exhibition at Beijing Gallery 
            </p>
            <p id="art-paragraph-bottom-mobile">
            Opening reception or free event day for your exhibition at Beijing Gallery 
              </p>
            <ul id="list">
                <li id="bullet">
                1. Your personal or group exhibition at the opening ceremony of the Beijing Gallery (signing an exhibition contract before traveling to China)
                </li>
                <li id="bullet">
                2. Visit the Beijing Art District 
                </li>
                <li id="bullet">
                3. Enjoy a free day in Beijing. Explore the capital of China alone. 
                </li> 
              </ul> 
            <p id="art-paragraph-bottom">
            Overnight in Beijing 
            </p>
            <p id="art-paragraph-bottom-mobile">
            Overnight in Beijing 
              </p>
            <br /> 

            <h5 id="caption-uh">
            Day 3:  Beijing
            </h5>
            <p id="art-paragraph-other">
            Your exploration of Beijing begins with a visit to Tiananmen Square, one of the largest public squares in the 
            world, and then into the Forbidden City. The Forbidden City, also officially known as the Palace Museum, was 
            originally built by the third emperor of the Ming Dynasty, Yongle Emperor. There were 24 emperors who lived here. 
            This palace was built between 1406 and 1420, but after numerous burns, reconstructions, demolitions and renovations, 
            most of the buildings you can see today date back to the 1700s. Then, visit the Pearl Factory to gain some knowledge 
            about fresh pearls. 
            </p>
            <br /> 

            <h5 id="caption-uh">
            Day 4:  Beijing 
            </h5>
            <p id="art-paragraph-other">
            On the way to the Great Wall, you will stop at the Jade Museum to learn the history of jade. Jade is pronounced 
            "jade" in China and has a history of at least 4,000 years in China. As they create complex designs, look at skilled 
            technicians. Then drive along the scenic countryside and mountains to the Great Wall, China's most famous monument. 
            There are fewer visitors and the original Juyong Pass, and try to avoid using the most accessible and therefore the 
            most crowded areas. The Great Wall winds through the mountains of northern China, from the Yellow Sea to the Gobi 
            Desert, more than 3,500 miles! 
            </p>
            <br /> 

            <h5 id="caption-uh">
            Day 5:  Beijing
            </h5>
            <p id="art-paragraph-bottom">
            Retrieve gallery works, receive money from free sales or free activities, and enjoy a free day in Beijing. 
            </p> 
            <p id="art-paragraph-bottom-mobile">
            Retrieve gallery works, receive money from free sales or free activities, and enjoy a free day in Beijing. 
            </p> 
            <br /> 

            <h5 id="caption-uh">
            Day 6: Beijing / Hangzhou 
            </h5>
            <p id="art-paragraph-other">
            On this day we fly to Hangzhou, where The China Academy of Art is, and home to many galleries and collectors 
            who greatly appreciate art. We will go to the gallery to prepare for the opening reception for your art work 
            that night, or a free event 
            </p> 
            <br /> 

            <h5 id="caption-uh">
            Day 7: Hangzhou 
            </h5>
            <p id="art-paragraph-other">
            Hangzhou is considered the tea capital of China, so a visit to Hangzhou would not be complete without a trip 
            to a local tea house.  We will have a special visit to the Meijiawu Tea House in the hinterland of Xihu Park, 
            which is considered one of the most important Longjing tea products in China. Enjoy the natural environment 
            and beautiful rural scenery, while learning more about its special tea culture and how to appreciate the fresh 
            aroma of Longjing tea. In the teahouse, you will learn how to make Longjing tea, including picking, frying, 
            and tasting tea leaves. Afterwards, take a boat cruise on the West Lake, a UNESCO World Heritage Site, which 
            reveals the ethereal beauty of Hangzhou's willow and weeping willow islands. 
            </p> 
            <br /> 

            <h5 id="caption-uh">
            Day 8: Hangzhou
            </h5>
            <p id="art-paragraph-other">
            Free time in Hangzhou or 2-3 hours by car to visit the artist's base (at your own expense). In the arms of 
            beautiful mountains and water and natural woods, you will visit the artist's free studio, and you can also 
            apply for the future Free studio to paint and sketch in this beautiful nature rnvironment. In the evening, 
            we will stay at a hotel in Hangzhou or the artist's base. 
            </p> 
            <br /> 

            <h5 id="caption-uh">
            Day 9: Hangzhou / Shanghai 
            </h5>
            <p id="art-paragraph-other">
            In the morning, drive to Shanghai and visit the famous Bund. Shanghai is divided into east and west by the 
            Huangpu River. Modern large high-rise buildings can be seen in the east, while traditional European buildings 
            can be seen in the west. The Bund is a five-block waterfront promenade with many banks and trading houses in 
            Shanghai. China is famous for silk, so to be sure, we will take you to a silk mill. Then escort you to the 
            hotel to rest. 
            </p> 
            <br /> 
            
            <h5 id="caption-uh">
            Day 10: Shanghai
            </h5>
            <p id="art-paragraph-other">
            After breakfast, you will visit Yu Garden, a classic garden among Shanghai's must-visit attractions. Its history 
            dates back to the Ming Dynasty (1368-1644) and was owned by a government official named Pan Yunyun. Yu Chinese means 
            pleasure and contentment. This garden was built for Pan's parents. It is a place where they could enjoy peaceful and 
            happy time in their old age.  Later in the day , we would visit the Huang Temple in the city, and it is  called 
            "Old Street". It refers to an ancient neighborhood with more than 100 temples, restaurants and shops. The area 
            contains narrow driveways and small squares in an "old China" environment. 
            </p> 
            <br /> 

            <h5 id="caption-uh">
            Day 11: Departure from Shanghai 
            </h5>
            <p id="art-paragraph-bottom">
            After breakfast, you will be transferred to the airport for your flight home. 
            </p> 
            <p id="art-paragraph-bottom-mobile">
            After breakfast, you will be transferred to the airport for your flight home. 
            </p> 
            <br /> 

            <br /> 

            <p id="art-paragraph-poem">
            *The above itinerary is for your reference, or if you have other ideas, we can meet your wishes, help you and your 
            work get more attention, and the best success.*
            </p>

          </div>
        </> 
    );
  }
  
  export default ArtService;